// eslint-disable-next-line import/no-cycle
import { IPageData } from 'Models';
import CONFIG from 'Config';

export async function getPageData(slug: string): Promise<IPageData> {
  const data = await fetch(`${CONFIG.urls.cms}/${slug}`)
    .then(response => response.json());
  return data;
}
